
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M6.786 4.643V2.5H5.598m-1.91 0H2.5v2.143m0 2.571v2.572m0 2.571V14.5h1.188m1.91 0h1.188v-2.143m3.428 0V14.5H14.5v-12h-4.286v2.357m0 5.357L12 8.5m0 0-1.786-1.714M12 8.5H6.5"}})])
          )
        }
      }
    